import { render } from "./KpiChat.vue?vue&type=template&id=7e63a10a&scoped=true"
import script from "./KpiChat.vue?vue&type=script&lang=js"
export * from "./KpiChat.vue?vue&type=script&lang=js"

import "./KpiChat.vue?vue&type=style&index=0&id=7e63a10a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e63a10a"]])

export default __exports__